import { ArrowDropDown, ArrowDropUp, Clear, SaveOutlined } from "@mui/icons-material";
import { Button, Card, CardActions, CardContent, FormControl, MenuItem, Select, Stack, Typography } from "@mui/material";
import { HidingError } from "components/errors";
import { isEqual } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetDevicePrefsQuery, useUpdateDevicePrefsMutation } from "services/data/deviceApi";
import styles from "./Prefs.module.css";

const DEFAULT_ERROR = "Ошибка соединения с сервером";

const Prefs = ({ profilesData }) => {
  const { id } = useParams();
  const { data, error, isLoading } = useGetDevicePrefsQuery({id});
  const [updateDevicePrefs, {error: updateDevicePrefsError, isLoading: isUpdatingDevicePrefs, reset: updateDevicePrefsReset}] = useUpdateDevicePrefsMutation();
  
  const [targetProfile, setTargetProfile] = useState(data?.body?.targetProfile);
  const [opened, setOpened] = useState(false);
  
  useEffect(() => {
    setTargetProfile(data?.body?.targetProfile);
  }, [data]);

  const isSaveButtonDisabled = useCallback( () => isEqual(data?.body?.targetProfile, targetProfile), [data, targetProfile]);
      
  const hideError = () => {
    if(updateDevicePrefsError) updateDevicePrefsReset();
  };
  
  const openError = () => { 
    return !!updateDevicePrefsError || false;
  };

  const getErrorMessage = () => { 
    if(updateDevicePrefsError) return updateDevicePrefsError?.data?.message ?? DEFAULT_ERROR;
  };

  const saveChanges = () => {
    const body = {...data?.body, targetProfile: targetProfile};
    updateDevicePrefs({devId: id, body: body});
  };

  const getTargetProfileIcon = () => {
    if(targetProfile) {
      return <Clear className={styles.targetProfileicon} onClick={ ()=> setTargetProfile('') } /> ;  
    } 
    return opened ? <ArrowDropUp className={styles.targetProfileicon} onClick={ ()=>setOpened(false)} />    
                  : <ArrowDropDown className={styles.targetProfileicon} onClick={ ()=>setOpened(true)} />;
  };

  return (
    <Card sx={{maxHeight: '100%', display: 'flex', flexDirection: 'column'}}>
      <HidingError 
        open={ openError() }
        message={ getErrorMessage() }
        onClose={hideError}
      /> 
      <CardContent sx={{overflow: 'auto'}}>
        <Stack direction="row" sx={{alignItems: 'center', justifyContent: 'space-between', width: '100%', overflow: 'hidden'}}>
          <Typography className="label">Назначенный профиль</Typography>
          <FormControl sx={{width: '50%'}}>
            <Select 
              size='small'
              value={targetProfile ?? ''}
              renderValue={(selected) => {
                if(selected.length === 0) return <em className={styles.placeholder}>Профиль не назначен</em>;
                return profilesData?.find(el => el.id === selected)?.name;
              }}
              displayEmpty={true}
              open={opened}
              onOpen={ () => setOpened(true) }
              onClose={ () => setOpened(false) }
              onChange={ (e) => setTargetProfile(e.target.value) }
              IconComponent={getTargetProfileIcon}
              sx={{my:1, width: '100%'}}
            >
                {
                  profilesData?.map(item => (
                    <MenuItem key={item.id} value={item.id}>
                          {item.name}
                    </MenuItem>
                  ))
                }
            </Select>
          </FormControl>                          
        </Stack>
      </CardContent>
      <CardActions sx={{px: 2}}>
        <Button
          fullWidth
          disabled={isSaveButtonDisabled()}
          startIcon={<SaveOutlined/>}
          color='error'
          variant='contained'
          sx={{my: 1}}
          onClick={saveChanges}
        >Сохранить</Button>    
      </CardActions>
    </Card> 
  );
};

export default Prefs;